module.exports = __webpack_public_path__ + "fonts/Corpos-Dem-Negrito.c95950b4.ttf";